module.exports = __webpack_public_path__ + "img/cup.307b425d.svg";